import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const WaitlistVerify = lazy(() => import("@/pages/WaitlistVerify"));

export const Route = createFileRoute("/join/verify")({
  component: WaitlistVerify,
});
